import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/ai-summary-icon.svg")